import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SplitLines, EASE } from "./motion";

const QA = [
  ["Preciso saber programar?", "Não. Você cola o HTML que a IA gerou (ou sobe o arquivo), edita clicando nos textos e publica. Se quiser mexer no código, tem um modo Código HTML com editor integrado — mas é opcional."],
  ["Funciona com HTML do ChatGPT e do Claude?", "Sim, esse é o caso de uso principal. O Lowpages aceita HTML pronto de qualquer IA e ainda extrai e otimiza imagens em base64 automaticamente. Com o conector MCP, você publica direto do chat."],
  ["Posso usar meu próprio domínio?", "Sim. Conecte de 1 a 15 domínios externos conforme o plano, ou compre um domínio sem sair da plataforma. SSL fica por nossa conta, com SEO por página."],
  ["Quanto tempo leva pra página ficar online?", "Segundos. Ao clicar em Publicar, a página ganha um link HTTPS na hora (/p/seu-endereco), com CDN e visitas ilimitadas."],
  ["Consigo editar a versão de celular separada?", "Sim. Estilos, textos e visibilidade de seções podem ser diferentes por dispositivo, com alternância desktop/celular dentro do editor."],
  ["E se eu quiser cancelar?", "Cancele a qualquer momento pelo painel. Todos os planos têm teste grátis, sem fidelidade. Você pode baixar o HTML standalone das suas páginas quando quiser."],
];

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="relative py-28 sm:py-36 px-6">
      <div className="mx-auto max-w-7xl grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal y={16} className="eyebrow mb-8">Perguntas</Reveal>
          <SplitLines as="h2" inView className="font-display font-bold tracking-[-0.03em] leading-[1] text-4xl sm:text-5xl text-[var(--ink)]" lines={["Dúvidas rápidas.", <span className="text-slate-400">Respostas diretas.</span>]} />
        </div>
        <ul className="lg:col-span-7 divide-y divide-slate-200 border-y border-slate-200">
          {QA.map(([q, a], i) => {
            const on = open === i;
            return (
              <li key={q}>
                <button data-testid={`faq-toggle-${i}`} aria-expanded={on} onClick={() => setOpen(on ? -1 : i)} className="w-full py-6 flex items-start justify-between gap-6 text-left group">
                  <span className={`font-display font-semibold text-lg sm:text-xl tracking-tight transition-colors ${on ? "text-[var(--blue)]" : "text-[var(--ink)] group-hover:text-[var(--blue)]"}`}>{q}</span>
                  <motion.span animate={{ rotate: on ? 45 : 0 }} transition={{ duration: 0.4, ease: EASE }} className={`mt-1 h-8 w-8 shrink-0 rounded-full grid place-items-center border transition-colors ${on ? "bg-[var(--blue)] border-[var(--blue)] text-white" : "border-slate-300 text-slate-500"}`}><Plus size={16} /></motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {on && (
                    <motion.div data-testid={`faq-answer-${i}`} initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.5, ease: EASE }} className="overflow-hidden">
                      <p className="pb-7 pr-14 text-slate-600 leading-relaxed">{a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
